/**
 * The staleness gate's two wizard surfaces, rendered ONCE above whichever step
 * is current (2026-09-15, commit 5):
 *   - the resume advisory banner (informs; blocks nothing)
 *   - the risk-stage fork dialog (three recorded arms)
 * Placed by both wizard pages (NewProcurement.jsx, ContinueProcurement.jsx)
 * rather than by individual steps: the advisory describes the document, not a
 * step, and the fork can be opened from the RFP step or the Risk step.
 *
 * THE STEP LINKS (2026-09-17). The banner's step names navigate, and do
 * NOTHING ELSE: setCurrentStep to that step's index. No cap on currentStep or
 * furthestStepReached, no unlock, no request - 62a017f removed the date check
 * from the load path because it capped both, and this must never restore it.
 * A step is NOT navigable, and renders as plain text, when it is:
 *   - the step the buyer is already on;
 *   - beyond furthestStepReached. setCurrentStep would not refuse it - the
 *     effect that tracks furthestStepReached would silently raise it past
 *     every step in between - so the check is made here;
 *   - on a completed procurement, which is a record and cannot be edited.
 */
import { useWizard, WIZARD_STEPS } from './WizardContext';
import MasterReferenceAdvisoryBanner from '@/components/MasterReferenceAdvisoryBanner';
import RiskCategoryForkDialog from './RiskCategoryForkDialog';

const stepIndex = (stepId) => WIZARD_STEPS.findIndex((s) => s.id === stepId);

const WizardMasterReferenceSurfaces = () => {
  const {
    masterReferenceAdvisory, finalLineCount, riskFork, riskForkBusy, handleRiskForkDecision,
    currentStep, furthestStepReached, setCurrentStep, procurementStatus,
  } = useWizard();
  const stepLink = {
    currentStep: WIZARD_STEPS[currentStep]?.id,
    isNavigable: (stepId) => {
      const i = stepIndex(stepId);
      return procurementStatus !== 'completed' && i !== -1 && i <= furthestStepReached && i !== currentStep;
    },
    navigate: (stepId) => setCurrentStep(stepIndex(stepId)),
  };
  return (
    <>
      <MasterReferenceAdvisoryBanner
        advisory={masterReferenceAdvisory}
        totalLines={finalLineCount}
        stepLink={stepLink}
        className="mb-6"
      />
      <RiskCategoryForkDialog
        open={Boolean(riskFork)}
        references={riskFork?.stale_references || []}
        busy={riskForkBusy}
        onDecision={handleRiskForkDecision}
      />
    </>
  );
};

export default WizardMasterReferenceSurfaces;
